<template>
    <div id="check_list_action_mapper_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="checkListActionHeader" v-if="$route.params.id > 0">Update Checklist Action Mapper</span>
                    <span class="page-title" id="checkListActionHeader" v-else>Add Checklist Action Mapper</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackChecklistActionMapperList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content checklist-mapper-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="checkListActionMapperForm">
                                <div class="form-row row-cols-md-2 row-cols-1">                                            
                                    <div class="col form-group">
                                        <label class="control-label require" for="parent_action">Parent Action:</label>
                                        <v-select v-model="parent_action" name="parent_action" placeholder="Select Parent Action."
                                                label="text" class="close-remove"
                                                :options="checkListActionArr" id="parent_action">
                                        </v-select>
                                        <div class="field-error">{{ parent_action_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="parent_action">Child Action:</label>
                                        <draggable v-model="childActionMapperArr" group="people" @start="drag=true" @end="drag=false" @change="dragRow">                                              
                                            <template v-for="(action, index) in childActionMapperArr">
                                                <div style="cursor:move;" class="w-100 pull-left mb-2" :key="index">
                                                    <i :key="'drag-icon'+index" class="fp-drag-icon drag-icon pull-left mt-2 mr-2" style="font-size:14px"></i>
                                                    <!-- <img :key="'drag-icon'+index" class="drag-icon pull-left mt-2 mr-2" src="/static/images/dragicon.png" alt="Fleetpro" height="15" width="15"> -->
                                                    <div class="w-50 pull-left">
                                                        <v-select v-model="action.childActionObj" :id="'selChildAction'+index" placeholder="Select Child Action."
                                                                label="text" class="close-remove"
                                                                :options="childActionArr" @input="childActionChange($event,index)">
                                                        </v-select>
                                                    </div>
                                                    <div class="mapper-remove-line-btn" :key="'add-remove'+index">
                                                        <template v-if="childActionMapperArr.length != 1">
                                                            <a class="remove-icon border pull-left" href="javascript:void(0)" v-on:click="removeLine($event,index)"> <i class="fp-remove color-red"></i> </a>
                                                        </template>
                                                    </div>
                                                </div>    
                                            </template>   
                                        </draggable>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <a class="btn btn-primary" href="javascript:void(0)" v-on:click="addLine(index)" > <i class="fp-add"></i>Add </a>
                                    <div class="error">{{ common_error_msg }}</div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups mt-4">
                                    <button type="submit" id="CreateCheckListActionMapperBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateChecklistActionMapper" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateCheckListActionMapperBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateChecklistActionMapper" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueCheckListActionMapperBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateChecklistActionMapper(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCheckListActionMapperBtn" class="btn btn-tertiary" v-on:click.prevent="BackChecklistActionMapperList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import draggable from 'vuedraggable'



export default {
  name: "ChecklistActionMapperCreate",
  components: {
        draggable,
        
    },
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Checklist Action Mapper | " +process.env.COPYRIGHT_NAME : "Create Checklist Action Mapper | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",    
    loading:false,
    parent_action:null,
    parent_action_error_msg:"",
    checkListActionArr:[],
    child_action:[], 
    child_action_error_msg:"",
    childActionArr:[],
    childActionMapperArr:[],
    removedListChildAction:[],
    common_error_msg:""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_checklist_action_mapper') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },

        parent_action:function(newValue,oldValue){
            console.log(oldValue);
            console.log(newValue);
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            // if(!segments[3]){
                if(self.parent_action == null || self.parent_action === ""){
                    self.childActionArr = [];
                    self.child_action = [];

                    //blank childActionMapperArr and add default row
                    self.childActionMapperArr = [];
                    self.childActionMapperArr.push({
                        childActionObj:null,
                        caId:0,
                        index:0
                    });

                    return;
                }else{
                    self.childActionArr = [];
                    self.child_action = [];

                    for(var i=0;i<self.checkListActionArr.length;i++){
                        if(self.checkListActionArr[i] != undefined){
                            if(newValue != null){
                                if(self.checkListActionArr[i].value != newValue.value){
                                    self.childActionArr.push(self.checkListActionArr[i]);
                                }
                            }
                        }
                    }

                    if(!segments[3]){
                        self.loading = true;
                        $.ajax({
                            url: process.env.ROOT_API + "/checklist-action-mapper/search",
                            type: "POST",
                            headers: this.ajxHeaders,
                            crossDomain: true,
                            dataType:"json",
                            data:{
                                parent_id:self.parent_action.value,
                            },
                            success: function (data) {
                                // console.log(data);
                                self.loading = false;
                                if(data.status == "success"){
                                    if(data.content.childActionArray.length > 0){
                                        self.childActionMapperArr = [];
                                        for(var i=0;i<data.content.childActionArray.length;i++){
                                            self.$set(self.childActionMapperArr,i,{
                                                childActionObj:{value:data.content.childActionArray[i].value,text:data.content.childActionArray[i].text},
                                                caId:data.content.childActionArray[i].caId,
                                                index:i //index of array                               
                                            });
                                        }
                                    }else{
                                        self.childActionMapperArr = [];
                                        self.childActionMapperArr.push({
                                            childActionObj:null,
                                            caId:0,
                                            index:0
                                        });
                                    }
                                }else{
                                    self.childActionMapperArr = [];
                                    self.childActionMapperArr.push({
                                        childActionObj:null,
                                        caId:0,
                                        index:0
                                    });
                                }
                                
                            },
                            error: function (jqXHR, exception) {
                                self.Registerbtn = "Register";
                                self.generateStatusCodeMessage(jqXHR,true,'checklist-action-mapper-search')
                            }
                        });
                    }
                }
            // }
            
        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['checkListAction']);
        //add default row
        self.childActionMapperArr.push({            
            childActionObj: null,
            caId:0,
            index:0
        });
        
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                self.loadChecklistActionMapper();
            }
        }, 100);
  },
  methods: {
    BackChecklistActionMapperList() {
      var self = this;
      self.$router.push("/checklist-action-mapper/list");
    },

    CreateChecklistActionMapper(flag) {
      var self = this;
      var error = false;
      self.parent_action_error_msg = "";  
      self.child_action_error_msg = "";
      self.common_error_msg = "";    

      if (self.parent_action == null || !self.parent_action.value) {
        self.parent_action_error_msg = "Parent Action Required.";
        error = true;
      }

      //child actions validations
      for(var i=0;i<self.childActionMapperArr.length;i++){

        if ( self.childActionMapperArr[i].childActionObj == null || self.childActionMapperArr[i].childActionObj.value == '' || !self.childActionMapperArr[i].childActionObj ) {                        
            $("#selChildAction"+i+" .dropdown-toggle").addClass('border-red');
            error = true;
        } else {                    
            $("#selChildAction"+i+" .dropdown-toggle").removeClass('border-red');
        }

      }

      //check for duplicate values
      if(self.checkDuplicateValues(self.childActionMapperArr)){
          self.common_error_msg = "Child Action cannot be added same.";
          error = true;
      }
      
      if (!error) {

            var childActionArrToSend = [];
            //generate array to send child actions
            for(var i=0;i<self.childActionMapperArr.length;i++){
                if(self.childActionMapperArr[i] != undefined){
                    if(self.childActionMapperArr[i].childActionObj != null){
                        
                        if(self.childActionMapperArr[i].childActionObj.value != ""){
                            
                            childActionArrToSend.push({
                                text:self.childActionMapperArr[i].childActionObj.text,
                                value:self.childActionMapperArr[i].childActionObj.value,
                                caId:self.childActionMapperArr[i].caId,
                                index:i //current index
                            });

                        }                    
                        
                    }
                }
            }
            
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateCheckListActionMapperBtn").val("Updating ...");
                $("#CreateCheckListActionMapperBtn").prop("disabled", true);
                $("#cancelCheckListActionMapperBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueCheckListActionMapperBtn").val("Saving ...");
                    $("#CreateCheckListActionMapperBtn").prop("disabled", true);
                    $("#createAndContinueCheckListActionMapperBtn").prop("disabled", true);
                    $("#cancelCheckListActionMapperBtn").prop("disabled",true);

                }else{

                    $("#CreateCheckListActionMapperBtn").val("Saving ...");
                    $("#CreateCheckListActionMapperBtn").prop("disabled", true);
                    $("#createAndContinueCheckListActionMapperBtn").prop("disabled", true);
                    $("#cancelCheckListActionMapperBtn").prop("disabled",true);
                }
               
            }

            var fields = $("#checkListActionMapperForm").serializeArray();
            fields.push({name: "parent_action", value: self.parent_action.value});
            fields.push({name: "id", value: segments[3]});            
            fields.push({name:"child_action",value: JSON.stringify(childActionArrToSend)});
            
            $.ajax({
                url: process.env.ROOT_API + "/checklist-action-mapper/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateCheckListActionMapperBtn").val("Update");
                        $("#CreateCheckListActionMapperBtn").prop("disabled", false);
                        $("#cancelCheckListActionMapperBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCheckListActionMapperBtn").val("Save and Continue");
                            $("#CreateCheckListActionMapperBtn").prop("disabled", false);
                            $("#createAndContinueCheckListActionMapperBtn").prop("disabled", false);
                            $("#cancelCheckListActionMapperBtn").prop("disabled",false);

                        }else{

                            $("#CreateCheckListActionMapperBtn").val("Save");
                            $("#CreateCheckListActionMapperBtn").prop("disabled", false);
                            $("#createAndContinueCheckListActionMapperBtn").prop("disabled", false);
                            $("#cancelCheckListActionMapperBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#checkListActionMapperForm").trigger("reset");
                            self.parent_action = null;
                            self.child_action = [];
                            self.childActionArr = [];
                            //blank childActionMapperArr and add default row
                            self.childActionMapperArr = [];
                            self.childActionMapperArr.push({
                                childActionObj:null,
                                caId:0,
                                index:0
                            });                        
                    
                        }else{
                            self.$router.push("/checklist-action-mapper/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateCheckListActionMapperBtn").val("Update");
                        $("#CreateCheckListActionMapperBtn").prop("disabled", false);
                        $("#cancelCheckListActionMapperBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#checkListActionMapperForm").trigger("reset");
                            

                            $("#createAndContinueCheckListActionMapperBtn").val("Save and Continue");
                            $("#CreateCheckListActionMapperBtn").prop("disabled", false);
                            $("#createAndContinueCheckListActionMapperBtn").prop("disabled", false);
                            $("#cancelCheckListActionMapperBtn").prop("disabled",false);

                        }else{

                            $("#CreateCheckListActionMapperBtn").val("Save");
                            $("#CreateCheckListActionMapperBtn").prop("disabled", false);
                            $("#createAndContinueCheckListActionMapperBtn").prop("disabled", false);
                            $("#cancelCheckListActionMapperBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'checklist-action-mapper-create')
                }
            });
      }
    },

    loadChecklistActionMapper() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/checklist-action-mapper/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                
                if (data.status == "success") {
                    self.parent_action = {value:data.content.parent_id, text:data.content.parent_action};
                    setTimeout(function(){
                        $("#parent_action").addClass("js-example-disabled");
                        self.child_action = data.content.childActionArray;
                        self.childActionMapperArr = [];
                        for(var i=0;i<data.content.childActionArray.length;i++){
                            self.$set(self.childActionMapperArr,i,{
                                childActionObj:{value:data.content.childActionArray[i].value,text:data.content.childActionArray[i].text},
                                caId:data.content.childActionArray[i].caId,
                                index:i //index of array                               
                            });
                        }
                    },100);
                                     
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'checklist-action-mapper-by-id')
            }
        });
    },
    addLine(index){
        var self = this;
        var error = false;
        var idx = self.childActionMapperArr.length;
        self.parent_action_error_msg = "";

        if (self.parent_action == null || !self.parent_action.value) {
            self.parent_action_error_msg = "Parent Action Required.";
            error = true;
        }

        for(var i=0;i<self.childActionMapperArr.length;i++){

            if(self.childActionMapperArr[i] != undefined){

                if ( self.childActionMapperArr[i].childActionObj == null || self.childActionMapperArr[i].childActionObj.value == '' || !self.childActionMapperArr[i].childActionObj ) {                        
                    $("#selChildAction"+i+" .dropdown-toggle").addClass('border-red');
                    error = true;
                } else {                    
                    $("#selChildAction"+i+" .dropdown-toggle").removeClass('border-red');
                }

            }

        }

        if(!error){
            self.childActionMapperArr.push({
                childActionObj: null,
                caId:0,
                index:self.childActionMapperArr.length    
            });
            // this.updateListChildAction(self.childActionMapperArr[idx - 1 ],'remove');
        }
       
    },
    removeLine(evt,index){
        var self = this;
         
        if( self.childActionMapperArr.length > 1 ) {

            var childActionId = self.childActionMapperArr[index].caId;            

            if(self.childActionMapperArr[index].caId == 0){

                // this.updateListChildAction(self.childActionMapperArr[index],'add' );
                self.childActionMapperArr.splice(index, 1);

            }else{

                self.removeChildAction(index,childActionId);
            }

        }
    },

    //when any row add or remove than update list child action
    updateListChildAction (field,flag) {
        var self = this;
        if ( field != null ) {
            
            if ( flag == "remove" ) {
                
                for ( var i=0; i < self.childActionArr.length; i++ ) { 
                    
                    if ( field.childActionObj == self.childActionArr[i] ) {
                        self.removedListChildAction.push(self.childActionArr[i]);
                        
                        delete self.childActionArr[i];
                        self.childActionArr.splice(i, 1);
                        
                        break;
                    }
                }

            }else{
                
                for ( var i=0; i < self.removedListChildAction.length; i++ ) { 
                        
                    if ( field.childActionObj == self.removedListChildAction[i] ) {                    
                        //check whether field is present in childActionArr or not
                        if(!self.childActionArr.includes(field.childActionObj)){
                            self.childActionArr.push(self.removedListChildAction[i]);
                            break;
                        }
                    }    
                }

            }

        }
    },
    //drag column and change updated column order object
    dragRow() {
        var self = this;
    },
    //remove child action 
    removeChildAction(index,caId){
        var self = this;

        if (confirm('Are you sure that you want to remove this? ')) {

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/checklist-action-mapper/delete",
                type: "POST",
                data: 'id=' + caId,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {                        
                    if (data.status == "success") {
                        
                        setTimeout(function () {
                            self.loadChecklistActionMapper();
                            // self.updateListChildAction(self.childActionMapperArr[index],'add' );
                        },50);                                              
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'checklist-action-mapper-delete')
                },
            });
        }
    },
    //child action selection change
    childActionChange(event,index){
        var self = this;
        var error = false
        if(self.childActionMapperArr[index].childActionObj != null){            
            
            for(var i=0;i<self.childActionMapperArr.length;i++){
                
                if( i != index){

                    if(self.childActionMapperArr[i].childActionObj != null){
                        
                        if(self.childActionMapperArr[i].childActionObj.value == event.value){
                            error = true;
                            alert("You have selected duplicate child action.");                        
                        }
                    }

                }    
            }

            //if same value found then blank particular index value
            if(error){
                if(self.childActionMapperArr[index].caId == 0){
                    self.childActionMapperArr[index].childActionObj = {text:"",value:""};                                
                }                
            }
        }
    },
    //check duplicate values in array
    checkDuplicateValues(arrayToCheck){
        var newArr = [];
        var found = false;

        for(var i=0;i<arrayToCheck.length;i++){
            
            if(arrayToCheck[i].childActionObj != null || arrayToCheck[i].childActionObj != undefined){
                if(!newArr.includes(arrayToCheck[i].childActionObj.value)){
                    newArr.push(arrayToCheck[i].childActionObj.value);
                }else{
                    found = true;
                }
            }

        }
        
        return found;
    }   
}
};
</script>



// WEBPACK FOOTER //
// src/components/ChecklistActionMapperCreate.vue